import FilterTab, { FilterTabItem } from 'components/common/FilterTab';
import SearchBox from 'components/common/SearchBox';
import { PitchDeck } from 'data/pitchdecks';
import { useAdvanceTableContext } from 'providers/AdvanceTableProvider';
import { ChangeEvent, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';

const TemplatesTopSection = () => {
  const { setGlobalFilter, getPrePaginationRowModel, getColumn } =
    useAdvanceTableContext<PitchDeck>();

  const handleFilterItemClick = (columnId: string, value: string) => {
    const column = getColumn(columnId);
    column?.setFilterValue(value === 'all' ? '' : value);
  };

  const tabItems: FilterTabItem[] = useMemo(() => {
    const getDataCount = (label: string) =>
      getPrePaginationRowModel().rows.filter(
        ({ original: { status } }) => status?.label === label
      ).length;

    return [
      {
        label: 'All',
        value: 'all',
        onClick: () => handleFilterItemClick('genre', 'all'),
        count: getPrePaginationRowModel().rows.length
      },
      {
        label: 'Comedy',
        value: 'comedy',
        onClick: () => handleFilterItemClick('genre', 'comedy'),
        count: getDataCount('comedy')
      },
      {
        label: 'Drama',
        value: 'drama',
        onClick: () => handleFilterItemClick('genre', 'drama'),
        count: getDataCount('drama')
      },
      {
        label: 'Mystery',
        value: 'mystery',
        onClick: () => handleFilterItemClick('genre', 'mystery'),
        count: getDataCount('mystery')
      },
      {
        label: 'Action',
        value: 'action',
        onClick: () => handleFilterItemClick('genre', 'action'),
        count: getDataCount('action')
      },
      {
        label: 'Family',
        value: 'family',
        onClick: () => handleFilterItemClick('genre', 'family'),
        count: getDataCount('family')
      },
      {
        label: 'Thriller',
        value: 'thriller',
        onClick: () => handleFilterItemClick('genre', 'thriller'),
        count: getDataCount('thriller')
      }
    ];
  }, [getPrePaginationRowModel]);

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setGlobalFilter(e.target.value || undefined);
  };

  return (
    <Row className="g-3 justify-content-between align-items-center mb-4">
      <Col xs={12} sm="auto">
        <FilterTab tabItems={tabItems} />
      </Col>
      <Col xs={12} sm="auto">
        <div className="d-flex align-items-center gap-1">
          <SearchBox
            onChange={handleSearchInputChange}
            placeholder="Search Templates"
            style={{ maxWidth: '30rem' }}
            className="me-3"
          />
        </div>
      </Col>
    </Row>
  );
};
export default TemplatesTopSection;
